import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ParEmployeeService } from '../../services/par_employees/par_employees.service';
import { documentInformation } from '../../model/document.model';
import { UploadService } from '../../services/upload/upload.service';
import * as momenttimezone from 'moment-timezone';
import { ChangeLogService } from '../../services/change_log/change-log.service';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';

@Component({
  selector: 'app-paremployee-document-upload-dialog',
  templateUrl: './paremployee-document-upload-dialog.component.html',
  styleUrls: ['./paremployee-document-upload-dialog.component.css']
})
export class ParemployeeDocumentUploadDialogComponent implements OnInit {
  DocListErrMsg;
  DocListErr: boolean = false;
  errMsg: any;
  errFlag: boolean = false;
  chooseFile: boolean = false;
  updateFile: boolean = false;
  onChangeFileName: string;
  onChangeFile: boolean = false;
  isFileChanged: boolean = false;
  documentInfo: documentInformation = new documentInformation();
  errorMsg: boolean = false;
  parEmployeeDocumentsDetailsAdded: any;
  public submitFormData: any;
  loginId;
  data: any = {
    docid: "",
    employee_id: '',
    document_type_code: "",
    document_type_name: "",
    document_link: "",
    file_name: "",
    expiration_date: "",
    completion_date: "",
    issue_date: "",
    uploaded_date: "",
    externalURL: "",
  };
  currentDate = new Date();
  submitSuccess;
  message;
  public employeeId: any;
  getAllPAREmployeeDataById: any[] = [];
  logFormData: any;
  uploadFlag : boolean = true;
  matSpinner: boolean = false;
  signedUrl;
  newFilePath;
  newFilePath1;
  firstName;
  lastName;
  previousValues: any = [];
  constructor( private googleAnalyticsService:GoogleAnalyticsService,
    private changelogservice: ChangeLogService, public dialogRef: MatDialogRef<ParemployeeDocumentUploadDialogComponent>, public ref: ChangeDetectorRef, private parEmployeeService: ParEmployeeService,
    @Inject(MAT_DIALOG_DATA) public DocumentData: any, private uploadService: UploadService) { }
  ngOnInit() {
    this.currentDate = new Date();
    this.employeeId = localStorage.getItem("ParEmployeeID");
    this.loginId = localStorage.getItem('loginID');
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.data.employee_id = this.employeeId;
    if (this.DocumentData.type === 'update') {
      this.data.externalURL = this.DocumentData.data.DocumentLink;
    }
    this.parEmployeeService.getParEmployeeBy_Id(this.employeeId).subscribe(res => {
      this.getAllPAREmployeeDataById = res;
    });
    this.getEmployeeDetailsToEdit();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  getEmployeeDetailsToEdit() {
    if (this.DocumentData.data.ExpirationDate != null) {
      let dt = new Date(this.DocumentData.data.ExpirationDate);
      if(dt !== undefined) {
        this.data.expiration_date = dt;
      }
    }

    this.data.completion_date = this.DocumentData.data.CompletionDate;
    this.data.docid = this.DocumentData.data._id;
    this.data.file_name = this.DocumentData.data.FileName;
    this.setFileDataEdit(this.DocumentData);
    this.data.document_link = this.DocumentData.data.DocumentLink;
  }

  setFileDataEdit(DocumentData) {
    this.documentInfo.fileName = DocumentData.data.FileName;
  }

  setFileData(docInfo) {
    this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Uploaded a" + ' ' +  this.DocumentData.data.DocumentTypeName+ ' ' + 'Document', 'PAR North America', 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.data.file_name = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    this.isFileChanged = true;
  }

  onFileChange(event) {
    this.isFileChanged = true;
    this.onChangeFile = false;
    const reader = new FileReader();
    const formInput: FormData = new FormData();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      this.onChangeFileName = file.name;
      var extName = file.name.split('.').pop();
      var ext = extName.toLowerCase()
      if (ext === 'docx' || ext === 'pdf' || ext === 'doc' || ext === 'png' || ext === 'jpg' || ext === 'xls' || ext === 'xlsx') {
        formInput.append('file', file, file.name);
        this.errorMsg = false;
      } else {
        this.errorMsg = true;
      }
    }
  }


  saveDocument() {
    this.matSpinner = true;
    this.uploadFlag = false;
    let today = new Date();
    const estTimeZone = 'America/New_York';
    let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
      uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');
    if (this.isFileChanged === false && this.DocumentData.type === 'update') {
      this.submitForm();
    } else {
      var filePath = "Par/" + 'parEmployeeDocs/' + this.DocumentData.data.DocumentTypeCode + '/';
      this.data.fileName = this.documentInfo.fileName;
      let fileNameWithoutExt = this.documentInfo.fileName.substring(0, this.documentInfo.fileName.lastIndexOf('.'));
      let fileNameExt = this.documentInfo.fileName.substring(this.documentInfo.fileName.lastIndexOf('.') + 1, this.documentInfo.fileName.length);
      this.documentInfo.fileInput.append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
      this.newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
      let body = {
        "newFilePath" : this.newFilePath1
      }
      this.uploadService.getSignedURL(body).subscribe((res) => {
       this.signedUrl = res.Info;
       this.uploadService.uploadDocumentWithSignedUrl(this.documentInfo.file, this.signedUrl).subscribe((obj) => {
        this.data.externalURL = this.newFilePath1;
        this.submitForm();
      });
      }, (err) => {
        
        this.matSpinner=false;
      });
    }
  }
  submitForm() {
    const setTime = new Date(this.data.expiration_date);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }
    this.submitFormData = {
      'document_type_code': this.DocumentData.data.DocumentTypeCode,
      'document_type_name': this.DocumentData.data.DocumentTypeName,
      'file_name': this.data.file_name,
      'expiration_date': testTimeZone, // testTimeZone,
      'document_link': this.data.externalURL,
      'completion_date': this.data.completion_date,
    };
    this.logFormData = {
      "document_type": this.DocumentData.data.DocumentTypeName,
      "document_category": this.DocumentData.data.DocumentCategory,
      "transaction_type": "Add"
    }
    if (this.DocumentData.type === 'update') {
      this.submitFormData.docid = this.data.docid;
      this.submitFormData.document_link = this.data.document_link;
      this.parEmployeeService.parEmployeeDocumentEdited(this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Updated a" + ' ' +  this.DocumentData.data.DocumentTypeName+ ' ' + 'Document', 'PAR North America', 10);
        if (res.Info === 'PAR Employee document updated') {
          this.submitSuccess = true;
          this.message = 'Document Data Upadated Successful';
          this.parEmployeeService.load.next('success');
          this.onNoClick();
          this.logFormData.modified_by = this.loginId;
          if (this.logFormData.transaction_type == "Add") {
            this.logFormData.transaction_type = "Edit";
            this.previousValues = localStorage.getItem('old');
            this.logFormData.previous_fields = JSON.parse(this.previousValues);
            this.logFormData.previous_fields.EmployeeName = localStorage.getItem('EmployeeName');
            this.logFormData.collection_name = "par_employee_documents";
            this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
              this.errMsg = 'PAR Change Logs' + ' ' + err;
              this.errFlag = true;
              this.matSpinner=false;
            });
          }
        } else {
          this.message = 'Data is not submitted';
        }
      }, err => {
        this.DocListErrMsg = "PAR Employee Document Updation" + err;
        this.DocListErr = true;
        this.matSpinner=false;
      });
    } else if (this.DocumentData.type === 'create') {
      this.submitFormData.employee_id = this.data.employee_id;
      this.parEmployeeService.addParEmployeeDocuments(this.submitFormData).subscribe(res => {
        this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Created a" + ' ' +  this.DocumentData.data.DocumentTypeName+ ' ' + 'Document', 'PAR North America', 10);
        if (res.Info === 'Employee Document Created') {
          this.submitSuccess = true;
          this.message = 'Employee Data Created Successful';
          this.parEmployeeService.load.next('success');
          this.onNoClick();
          this.logFormData.modified_by = this.loginId;
          this.logFormData.employee_name = localStorage.getItem('EmployeeName');
          this.changelogservice.sendLogs(this.logFormData).subscribe(res => { }, err => {
            this.errMsg = 'PAR Change Logs' + ' ' + err;
            this.errFlag = true;
            this.matSpinner=false;
          });
        } else {
          this.message = 'Data is not submitted';
        }
      }, err => {
        this.DocListErrMsg = "PAR Employee Document Creation" + err;
        this.DocListErr = true;
        this.matSpinner=false;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/paremployee-document-upload-dialog/paremployee-document-upload-dialog.component.ts